import { callAPi } from './http-common';

const add = (data) => {
  return callAPi.post('/seo/addProducttoSeo', data);
};
const get = () => {
  return callAPi.get('/seo/getAll');
};
const getbyid = (id) => {
  return callAPi.get(`/seo/get/${id}`);
};
const update = (id, data) => {
  return callAPi.patch(`/seo/update/${id}`, data);
};
const deletes = (id) => {
  return callAPi.delete(`/seo/delete/${id}`);
};
const ProductSEOService = {
  add,
  get,
  update,
  deletes,
  getbyid,
};

export default ProductSEOService;
